import { UiLocale } from '@acs/shared';

/**
 * The query of our `/auth/action` link (doc 88 D4), built server-side as
 * `?mode=verifyEmail|resetPassword&oobCode=…&lang=…`.
 *
 * Only the two modes we send are accepted: Firebase has others (`signIn`,
 * `recoverEmail`, `verifyAndChangeEmail`) that this page does not implement,
 * and a code for one of those must not be applied as if it were ours.
 */
export interface ActionParams {
  mode: 'verifyEmail' | 'resetPassword';
  code: string;
  lang: UiLocale | null;
}

const CODE = /^[A-Za-z0-9_-]{1,512}$/;

export function parseActionParams(search: string): ActionParams | null {
  const q = new URLSearchParams(search);
  const mode = q.get('mode');
  const code = q.get('oobCode') ?? '';
  if (mode !== 'verifyEmail' && mode !== 'resetPassword') return null;
  if (!CODE.test(code)) return null;
  const lang = UiLocale.safeParse(q.get('lang'));
  return { mode, code, lang: lang.success ? lang.data : null };
}
